/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {correctPaymentAccountReference} from '../api'

export const useMutationCorrectPaymentAccountReference = createReactQueryMutationHook('correctPaymentAccountReference', correctPaymentAccountReference)
